import { NgModule } from "@angular/core";
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSortModule } from '@angular/material/sort';
import { MatSelectModule, MatSelect } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRadioModule } from '@angular/material/radio';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTreeModule } from '@angular/material/tree';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSliderModule } from '@angular/material/slider';
import { MatBadgeModule } from '@angular/material/badge';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DomSanitizer } from "@angular/platform-browser";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatOptionModule } from '@angular/material/core';
import { DhhpButtonModule } from 'dhhp-button';
import { DhhpCardModule } from 'dhhp-card';
import { PasswordManagerModule } from 'password-manager';
// import { PasswordManagerModule } from '../core/dhhp-feature-components/password-manager/projects';
// import { DhhpCardModule } from 'dhhp-card';

const modules = [
    MatAutocompleteModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatMenuModule,
    MatSidenavModule,
    MatToolbarModule,
    MatSlideToggleModule,
    MatListModule,
    MatCardModule,
    MatExpansionModule,
    MatBadgeModule,
    MatCheckboxModule,
    MatTableModule,
    MatRadioModule,
    MatOptionModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatSortModule,
    MatTreeModule,
    MatTabsModule,
    MatSelectModule,
    MatPaginatorModule,
    MatButtonToggleModule,
    MatSnackBarModule,
    MatChipsModule,
    MatStepperModule,
    MatDividerModule,
    MatTooltipModule, MatDialogModule,DhhpButtonModule,
    DhhpCardModule,
    PasswordManagerModule
]
@NgModule({
    imports: [],
    exports: [modules]
})
export class MaterialModule {
    constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {
        this.matIconRegistry.addSvgIcon("Institutional-User", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/img/svg/Institutional-User.svg"));
        this.matIconRegistry.addSvgIcon("Profession-Account", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/img/svg/Profession-Account.svg"));
        this.matIconRegistry.addSvgIcon("Personal-Account", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/img/svg/Personal-Account.svg"));
        this.matIconRegistry.addSvgIcon("filterimg", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/img/svg/FIlter.svg"));
        this.matIconRegistry.addSvgIcon("Column-Selector", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/img/AU-img/Selector-icon.svg"));
        this.matIconRegistry.addSvgIcon("Exporting", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/img/svg/icon_export.svg"));
        this.matIconRegistry.addSvgIcon("filteractive", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/img/svg/FIlter-active.svg"));
        this.matIconRegistry.addSvgIcon("Back", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/img/svg/Back.svg"));
        this.matIconRegistry.addSvgIcon("configure", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/img/svg/icon_configure.svg"));
        this.matIconRegistry.addSvgIcon("health-plus", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/img/svg/health-plus.svg"));
        this.matIconRegistry.addSvgIcon("health-plus-login", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/img/svg/health-plus-login.svg"));
        this.matIconRegistry.addSvgIcon("facility", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/img/svg/facility.svg"));
        this.matIconRegistry.addSvgIcon("communication", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/img/svg/communication.svg"));
        this.matIconRegistry.addSvgIcon("Assets", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/img/svg/Assets.svg"));
        this.matIconRegistry.addSvgIcon("Message", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/img/svg/Message.svg"));
        this.matIconRegistry.addSvgIcon("Update", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/img/svg/Update.svg"));
        this.matIconRegistry.addSvgIcon("pending_icon", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/img/svg/pending_icon.svg"));
        this.matIconRegistry.addSvgIcon("hamburger", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/img/AU-img/hamburger_menu1.svg"));
        this.matIconRegistry.addSvgIcon("settingmenu", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/img/AU-img/setting_icon.svg"));
        this.matIconRegistry.addSvgIcon("communicationnav", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/img/svg/communication-nav.svg"));
        this.matIconRegistry.addSvgIcon("not_associated", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/img/svg/alert_icon.svg"));
        this.matIconRegistry.addSvgIcon("Alert", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/img/svg/alert.svg"));
    }
}
